import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Icon } from '@chegg/ui-agnostic'
import { fanta } from '@chegg/fanta'
import { StoreState } from '../reducer/types'
import { ErrorContainer, ErrorText, ErrorCloseContainer } from '../styles'
import { ERROR_FILETYPE_COPY, ERROR_MAX_COPY, ERROR_DEFAULT_COPY } from '../constants'
import { closeErrorMessage } from '../actions/upload'

export type ErrorMessagesProps = {
  alertFileSize: boolean
  alertFileType: boolean
  maxFileSize: number
  uploadError: boolean
  dismiss: () => void
}
export const ERROR_CLOSE_TEST_ID = `errorClose`
const importantSize = 20 * 1.5
const cancelSize = 12 * 1.5

export const ErrorMessages: React.FunctionComponent<ErrorMessagesProps> = ({
  alertFileSize,
  alertFileType,
  maxFileSize,
  uploadError,
  dismiss,
}) => {
  const hasError = alertFileType || alertFileSize || uploadError
  if (!hasError) {
    return null
  }

  let msg: string = ''

  if (alertFileType) {
    msg = ERROR_FILETYPE_COPY
  } else if (alertFileSize) {
    msg = ERROR_MAX_COPY
  } else if (uploadError) {
    msg = ERROR_DEFAULT_COPY
  }

  return (
    <ErrorContainer>
      <Icon.Important color={fanta.colors.errorRed} width={importantSize} />
      <ErrorText>{msg}</ErrorText>
      <ErrorCloseContainer>
        <Icon.Cancel
          color={fanta.colors.greyMedium}
          width={cancelSize}
          onClick={dismiss}
          data-test-id={ERROR_CLOSE_TEST_ID}
        />
      </ErrorCloseContainer>
    </ErrorContainer>
  )
}
const mapStateToProps = (state: StoreState) => ({
  uploadError: state.upload.error,
  alertFileSize: state.ui.alertFileSize,
  alertFileType: state.ui.alertFileType,
  maxFileSize: state.app.upload ? state.app.upload.filesize.max / 1024 / 1024 : 0,
})
const mapDispatchToProps = (dispatch: Dispatch) => ({
  dismiss: () => {
    dispatch(closeErrorMessage())
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessages)
